export default "__VITE_ASSET__c27123bc__"